module.exports = "data:image/webp;base64,UklGRu4AAABXRUJQVlA4IOIAAAAwBgCdASoZABkAPpFAmUmlo6IhKAqosBIJaQDKu3gd4J9Scwaaw+KIpvEIpLO2JsQ789pUNYmpzDIAAP7o+NoyCu9aaohtm5r31jGU6KkJn5Cc8paXfuYAC0tSEiOTlCCHk4iFiVuw+YBbpcvJD7nf7rQIdguO8Iu91ye4MYyJtlYJYB/vTH2SENOJF6TiVLOghqK46+zRM30gpIiyUoVoDMu95l3VlfIc1exiv8BNDBHw1HvFh2Exqi75vd5uIJUd+sImS7wbH5P8hgtsEl7w5xSvp5Mdlnhnt61rGr1YAAAA"


//////////////////
// WEBPACK FOOTER
// ./src/assets/color/grey-wash.webp
// module id = 7oGs
// module chunks = 14